import { render, staticRenderFns } from "./KeHuSiXiang.vue?vue&type=template&id=0d2828ac&scoped=true&"
import script from "./KeHuSiXiang.vue?vue&type=script&lang=js&"
export * from "./KeHuSiXiang.vue?vue&type=script&lang=js&"
import style0 from "./KeHuSiXiang.vue?vue&type=style&index=0&id=0d2828ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2828ac",
  null
  
)

export default component.exports